import { render } from "./Loading.vue?vue&type=template&id=cbb2403a"
import script from "./Loading.vue?vue&type=script&lang=js"
export * from "./Loading.vue?vue&type=script&lang=js"
script.render = render

export default script